import { CSSProperties } from "react";
import FontWeight from "../../../../../models/constants/FontWeight";

export default class InjuryInfoViewStyle {

    form : CSSProperties = {
        display : 'flex', 
        flexDirection : 'column', 
        flex : 1, 
        justifyContent : 'space-between',
        marginTop:20 
    }

    label : CSSProperties = {
        fontFamily : 'Roboto',
        fontWeight : FontWeight.LIGHT,
        fontSize : 13,
        color : '#9F9F9F'
    }
}